import { render, staticRenderFns } from "./Urvalssortering.vue?vue&type=template&id=2420ed7a&scoped=true&"
import script from "./Urvalssortering.vue?vue&type=script&lang=js&"
export * from "./Urvalssortering.vue?vue&type=script&lang=js&"
import style0 from "./Urvalssortering.vue?vue&type=style&index=0&id=2420ed7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2420ed7a",
  null
  
)

export default component.exports